import { lazy } from "react"
import { Navigate } from "react-router-dom"
import type { CustomRoute } from "@/shared/types"
import ErrorPage from "@/shared/ui/error-page.tsx"

const AuditRequestPage = lazy(async () => await import("@/pages/dashboard/inspection-energy-audit/inprogress/in-search-auditor/audit-request"))
const AuditProgramPage = lazy(async () => await import("@/features/audit-program/ui"))
const InProgressNew = lazy(async () => await import("@/pages/dashboard/inspection-energy-audit/inprogress/new"))

const InProgressInSearchAuditor = lazy(async () => await import("@/pages/dashboard/inspection-energy-audit/inprogress/in-search-auditor"))
const InProgressContractSigned = lazy(async () => await import("@/pages/dashboard/inspection-energy-audit/inprogress/contract-signed"))
const InProgressProgramApproved = lazy(async () => await import("@/pages/dashboard/inspection-energy-audit/inprogress/program-approved"))
const InProgressAuditInProgress = lazy(async () => await import("@/pages/dashboard/inspection-energy-audit/inprogress/audit-in-progress"))
const InProgressAuditCompleted = lazy(async () => await import("@/pages/dashboard/inspection-energy-audit/inprogress/audit-completed"))
const InProgressAuditCompletedResultsEnergyAccounting = lazy(
  async () => await import("@/pages/dashboard/inspection-energy-audit/inprogress/audit-completed/results/energy-accounting")
)
const InProgressAuditCompletedResultsEnergyBalance = lazy(
  async () => await import("@/pages/dashboard/inspection-energy-audit/inprogress/audit-completed/results/energy-balance")
)
const InProgressAuditCompletedResultsComparativeDynamics = lazy(
  async () => await import("@/pages/dashboard/inspection-energy-audit/inprogress/audit-completed/results/comparative-dynamics")
)
const InProgressOtm = lazy(async () => await import("@/pages/dashboard/inspection-energy-audit/inprogress/otm"))
const InProgressOtmView = lazy(async () => await import("@/pages/dashboard/inspection-energy-audit/inprogress/otm/view"))
// const InProgressOtmViewComment = lazy(async () => await import("@/pages/dashboard/inspection-energy-audit/inprogress/audit-completed/comment"))
const InProgressOtmViewComment = lazy(async () => await import("@/pages/dashboard/inspection-energy-audit/inprogress/audit-completed/otm-view"))
const InProgressOTMReportComment = lazy(async () => await import("@/pages/dashboard/inspection-energy-audit/inprogress/audit-completed/comment"))

export const inspectionEnergyAuditInProgressRoutes: CustomRoute = {
  handle: {
    label: "В процессе",
    i18Key: "periodic-mandatory",
    ignoreChildren: true
  },
  path: "periodic-mandatory",
  errorElement: <ErrorPage />,
  children: [
    {
      path: "",
      element: <Navigate to="new" />
    },
    {
      path: "new",
      handle: { label: "Новые", i18Key: "new" },
      Component: InProgressNew
    },
    {
      path: "search-auditor",
      handle: { label: "Новые", i18Key: "in-search-auditor" },
      children: [
        {
          path: "",
          Component: InProgressInSearchAuditor
        },
        {
          path: "announcement/:announcementId",
          handle: { label: "Объявление", i18Key: "announcement" },
          Component: AuditRequestPage
        }
      ]
    },
    {
      path: "contract-signed",
      handle: { label: "Договор подписан", i18Key: "contract_signed" },
      Component: InProgressContractSigned
    },
    {
      path: "program-approvals",
      handle: { label: "Посмотреть", i18Key: "program_approvals" },
      Component: InProgressProgramApproved
    },
    {
      path: "program-approvals/:programId",
      handle: { label: "Посмотреть", i18Key: "program_approvals" },
      Component: AuditProgramPage
    },
    {
      path: "audit-in-progress",
      handle: { label: "Аудит в процессе", i18Key: "audit_inprogress" },
      Component: InProgressAuditInProgress
    },
    {
      path: "audit-completed",
      handle: { label: "Аудит завершен", i18Key: "audit_completed", ignoreChildren: true },
      children: [
        {
          index: true,
          Component: InProgressAuditCompleted
        },
        {
          path: ":energy_audit_id/comment",
          handle: { label: "Комментарий", i18Key: "comment" },
          Component: InProgressOTMReportComment
        },
        {
          path: ":energy_audit_id/otm",
          handle: { label: "Комментарий", i18Key: "comment_otm" },
          Component: InProgressOtmViewComment
        },
        {
          handle: {
            label: "Результаты",
            i18Key: "results",
            ignoreChildren: true
          },
          path: "results",
          children: [
            {
              index: true,
              Component: InProgressAuditCompletedResultsEnergyAccounting
            },
            {
              path: ":energy_audit_company_id/energy-accounting",
              handle: { label: "Учёт энергоресурсов", i18Key: "energy_accounting" },
              Component: InProgressAuditCompletedResultsEnergyAccounting
            },
            {
              path: ":energy_audit_company_id/energy-balance",
              handle: { label: "Энергетический баланс", i18Key: "energy_balance" },
              Component: InProgressAuditCompletedResultsEnergyBalance
            },
            {
              path: ":energy_audit_company_id/comparative-dynamics",
              handle: { label: "Сравнительная динамика", i18Key: "comparative_dynamics" },
              Component: InProgressAuditCompletedResultsComparativeDynamics
            }
          ]
        }
      ]
    },
    {
      path: "otm",
      handle: { label: "ОТМ", i18Key: "otm", ignoreChildren: true },
      children: [
        {
          index: true,
          Component: InProgressOtm
        },
        {
          path: "view/:energy_audit_company_id",
          handle: { label: "Учёт энергоресурсов", i18Key: "OTM_view" },
          Component: InProgressOtmView
        }
      ]
    }
  ]
}
